import { Message } from 'sugar-design';

const DEFAULT_DURATION = 3000;

export const successToast = (message, id) => {
  Message.sendMessage({
    type: 'success',
    content: message,
    duration: DEFAULT_DURATION,
    isLoading: false,
    id,
  });
};

export const errorToast = (message, id) => {
  Message.sendMessage({
    type: 'error',
    content: message,
    duration: DEFAULT_DURATION,
    isLoading: false,
    id,
  });
};

export const loadingToast = (message, id) => {
  Message.sendMessage({
    type: 'info',
    content: message,
    duration: DEFAULT_DURATION,
    isLoading: false,
    id,
  });
};
